import { useMst } from '@PillPez/models';
import { useParams } from 'react-router';
import {
  ConfirmationMessage,
  SecondaryMessage,
  ConfirmationButtons,
  ModalWrapper,
} from './styles/confirmation-modal.style';

interface ConfirmationModalProps {
  onConfirm: () => void;
  onCancel: () => void;
  message?: string;
  id?: string;
  actionFunc: () => void;
}

export const DeleteDeviceConfirmationModal = ({ onConfirm, onCancel, id, actionFunc }: ConfirmationModalProps) => {
  const { detachDevice } = useMst();
  const { enduserId } = useParams();
  const deleteEnduserDevice = async (id: string | undefined) => {
    let resp = await detachDevice.detachDevice(id, enduserId);
    console.log(resp);
    actionFunc();
  }

  return (
    <ModalWrapper>
      <ConfirmationMessage>Are you sure you want to delete this?</ConfirmationMessage>
      <SecondaryMessage>This action cannot be undone</SecondaryMessage>
      <ConfirmationButtons>
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            onCancel();
          }}
          className="portal-white-button"
        >
          Cancel
        </a>
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            onConfirm();
            deleteEnduserDevice(id)
            console.log(id)
          }}
          className="portal-button"
        >
          Delete
        </a>
      </ConfirmationButtons>
    </ModalWrapper>
  );
};